import { render, staticRenderFns } from "./GuardCodeCreate.vue?vue&type=template&id=452a518a"
import script from "./GuardCodeCreate.vue?vue&type=script&lang=ts"
export * from "./GuardCodeCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports